import { IGifReportParams } from "../../services/RedGifsService";
import { IAppAction } from "../appAction";

export const videoActions = {
  REPORT_GIF_BY_ID: "REPORT_GIF_BY_ID",
  REPORT_GIF_BY_ID_SUCCESS: "REPORT_GIF_BY_ID_SUCCESS",
  REPORT_GIF_BY_ID_ERROR: "REPORT_GIF_BY_ID_ERROR",
};

export const reportGifById = (params: IGifReportParams): IAppAction => ({
  type: videoActions.REPORT_GIF_BY_ID,
  payload: params
});

export const reportGifByIdSuccess = (payload: any): IAppAction => ({
  type: videoActions.REPORT_GIF_BY_ID_SUCCESS,
  payload
});

export const reportGifByIdError = (error: Error): IAppAction => ({
  type: videoActions.REPORT_GIF_BY_ID_ERROR,
  payload: error
});
